<template>
  <div class="code-input-page">
    <textarea ref="text" class="code" :style="{ maxHeight: `${height}px` }" @input="textChange" @blur="init"></textarea>
  </div>

</template>

<style lang="less" scoped>
@import 'CodeInput';
</style>

<script>
import CodeInput from './CodeInput'
export default CodeInput
</script>
